import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './guards/auth.guard';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';
import { DashboardComponent } from './shared/components/dashboard/dashboard.component';
import { IsNotSystemAdminGuard, IsUserAllowed } from './guards/route.guard';
import { featuresConstants } from './constants/features.constants';

const routes: Routes = [
  {
    path: 'implicit',
    loadChildren: () =>
      import('./modules/authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: 'auth',
    loadChildren: () =>
      import('./modules/authentication/authentication.module').then(
        (m) => m.AuthenticationModule
      ),
  },
  {
    path: '',
    canActivate: [AuthGuard],
    component: MainLayoutComponent,
    children: [
      {
        path: 'dashboard',
        data: { screen: featuresConstants.dashboard.type },
        canActivate: [IsUserAllowed, IsNotSystemAdminGuard],
        component: DashboardComponent,
      },
      {
        path: '',
        loadChildren: () =>
          import('./modules/claims/claims.module').then(
            (m) => m.ClaimsModule
          ),
      },
      {
        path: '',
        loadChildren: () =>
          import('./modules/batch-management/batch-management.module').then(
            (m) => m.BatchManagementModule
          ),
      },
      {
        path: 'client-management',
        data: { screen: featuresConstants.clientManagement.type },
        canActivate: [IsUserAllowed],
        loadChildren: () =>
          import('./modules/client-management/client-management.module').then(
            (m) => m.ClientManagementModule
          ),
      },
      {
        path: 'csv-field-mapper',
        data: { screen: featuresConstants.csvFieldMapper.type },
        canActivate: [IsUserAllowed, IsNotSystemAdminGuard],
        loadChildren: () =>
          import('./modules/csv-field-mapper/csv-field-mapper.module').then(
            (m) => m.CsvFieldMapperModule
          ),
      },
      {
        path: 'activity-logs',
        data: { screen: featuresConstants.activityLogs.type },
        canActivate: [IsUserAllowed, IsNotSystemAdminGuard],
        loadChildren: () =>
          import('./modules/activity-logs/activity-logs.module').then(
            (m) => m.ActivityLogsModule
          ),
      },
      // {
      //   path: 'batch-report',
      //   component: BatchReportComponent,
      // },
      {
        path: 'call-dialer',
        data: { screen: featuresConstants.callDialer.type },
        canActivate: [IsUserAllowed, IsNotSystemAdminGuard],
        loadChildren: () =>
          import('./modules/call-dialer/call-dialer.module').then(
            (m) => m.CallDialerModule
          ),
      },
      {
        path: 'management',
        // canActivate: [IsUserAllowed],
        loadChildren: () =>
          import(
            './modules/role-feature-management/role-feature-management.module'
          ).then((m) => m.RoleFeatureManagementModule),
      },
      {
        path: '',
        redirectTo: 'batch-management',
        pathMatch: 'full',
      },
    ],
  },
  {
    path: 'login',
    redirectTo: 'auth/callback',
  },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule {}
